// Feature flags stored in the backend `settings` table and toggled via the DB.
// Side-effect-free (no config/apollo imports) so the feature-flag loader,
// context and the useFeatureFlag hook can all import it freely.
export const DB_GUARANTEES_V2 = 'guarantees_v2';
export const DB_ELIGIBILITY_ENGINE = 'eligibility_engine';
export const DB_MULTI_SUBSCRIPTION = 'multi_subscription';
